/**
 * Type guard to check if the provided value is a function compatible with the expected signature.
 *
 * @template TParams The expected parameter types of the function.
 * @template TReturn The expected return type of the function.
 *
 * @param {unknown} fn - The value to check.
 * @throws {TypeError} If the provided value is not a function.
 * @returns {boolean} True if the value is a compatible function, false otherwise.
 *
 * @example
 * const selectFn = (data: UserResponse) => ({ name: data.name });
 * if (isFunctionWithSignature<[UserResponse], { name: string }>(selectFn)) {
 *   // TypeScript knows selectFn is compatible with (data: UserResponse) => { name: string }
 * }
 */
export function isFunctionWithSignature(fn: unknown) {
  if (typeof fn !== 'function') {
    throw new TypeError(`Expected a function, but received: ${typeof fn}`)
  }
  return true
}
